import { Box, Skeleton, useTheme } from '@mui/material';

interface SportsSidebarSkeletonProps {
  isMobile?: boolean;
}

export const SportsSidebarSkeleton = ({ isMobile = false }: SportsSidebarSkeletonProps) => {
  const theme = useTheme();

  if (isMobile) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 2,
          overflowX: 'auto',
          pb: 1,
          mx: { xs: -1.5, sm: -2, md: -3, lg: -4 },
          px: { xs: 1.5, sm: 2, md: 3, lg: 4 },
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
        }}
      >
        {/* Category placeholders */}
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <Skeleton
            key={`chip-${i}`}
            variant="rounded"
            width={64}
            height={64}
            sx={{ borderRadius: 1, flexShrink: 0 }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: theme.palette.background.paper,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '100%',
        minHeight: 400,
        boxSizing: 'border-box',
      }}
    >
      {/* Live / Futures buttons placeholders */}
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <Skeleton variant="rounded" width="50%" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width="50%" height={40} sx={{ borderRadius: 1 }} />
      </Box>

      <Box sx={{ height: 1, bgcolor: theme.palette.divider, my: 1, opacity: 0.1 }} />

      {/* All Sports section title */}
      <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1.5 }} />

      {/* List items */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, px: 1 }}>
            <Skeleton variant="circular" width={24} height={24} sx={{ opacity: 0.6 }} />
            <Skeleton variant="text" width="60%" height={20} />
            <Box sx={{ flex: 1 }} />
            <Skeleton variant="text" width={20} height={20} sx={{ opacity: 0.4 }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
